import * as angular from "angular";
import {IQService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {ApiConfig} from "../../commons/models/api-config.model";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";

export class SchedulingProjectRequests {

  constructor(private $q: IQService, private splitService: SplitService,
              private Upload, private apiConfig: ApiConfig, private bringozLoaderService: BringozLoaderService) {
  }

  validateVisitConfiguration(file) {
    const siteId = this.splitService.getSiteId();
    this.bringozLoaderService.on();
    return this.Upload.upload({
      url: this.apiConfig.baseUrl + `/importers-visit-configuration/validate`,
      method: 'POST',
      params: {siteId: siteId},
      data: {file: file}
    })
    .then((response) => {
      return this.$q.when(response.data);
    })
    .catch((response) => {
      return this.$q.reject(response.data);
    })
    .finally(() => {
      this.bringozLoaderService.off();
    })
  }
}

angular
  .module('bringoz.admin.scheduling-project')
  .service('schedulingProjectRequests', SchedulingProjectRequests);
